import { mapping as verifierDeviceBaseMapping } from '../common/verifier-device-base/verifier-device-sort.mapper'

export const mapping: Record<string, string> = {
  ...verifierDeviceBaseMapping,
}

const mapSortTerminalParam = (key: string) => mapping[key]

export default mapSortTerminalParam
